import { Box, Text } from '@grupoboticario/flora-react';
import { styled, theme, utils } from 'ui/theme';

const CarouselStyles = {
  Component: styled.div`
    &[data-container='true'] {
      position: relative;
    }
  `,

  Carousel: styled.div`
    overflow: hidden;

    &[data-container='true'] {
      &[data-fullcontent='false'] {
        margin: 0 ${theme.space[7]};

        ${utils.media.min('l')`
          margin: 0;
        `}
      }
    }
  `,

  Wrapper: styled(Box)`
    &[data-thumbnail='true'] {
      display: grid;
      grid-template-columns: 97px auto;

      svg {
        width: 40px;
        height: 40px;
      }
    }
  `,

  CarouselImgContent: styled(Box)`
    &[data-thumbnail='true'] {
      width: 100%;
      padding-right: 10px;
      padding-left: 15px;
      position: relative;
    }
  `,

  Thumbnail: styled.button`
    width: 97px;
    height: 95px;
    border: 1px solid ${theme.colors.build.mediumLight2};
    display: flex;
    margin: 6px;
    margin-top: 0px;
    border-radius: 2px;
    overflow: hidden;
    position: relative;
    align-items: center;
    padding: 0;
    cursor: pointer;

    img {
      width: 97px;
      height: 97px;
    }

    &[data-active='true'] {
      border-color: ${theme.colors.action.navigation.standard.highlight};
    }

    &[data-active='true']:after {
      background: ${theme.colors.action.navigation.standard.highlight};
      bottom: 0;
      content: '';
      left: 0;
      position: absolute;
      top: 0;
      width: 3px;
    }
  `,

  Count: styled(Text)`
    align-items: center;
    background: #fffc;
    bottom: 0;
    color: ${theme.colors.build.brand1};
    display: flex;
    font-size: ${theme.fontSizes['3xl']};
    font-weight: ${theme.fontWeights.heavy};
    justify-content: center;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
  `,
};

export default CarouselStyles;
